import {
  Colors,
  GOLD_400,
  GOLD_450,
  hexToRGB,
  MOON_250,
  MOON_650,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {keyframes} from 'styled-components';

export const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  margin: 20px 0 5px 0;
`;
SectionTitle.displayName = 'S.SectionTitle';

export const MetadataTable = styled.div`
  background-color: ${Colors.WHITE};
  width: 100%;
  border: 1px solid ${MOON_250};
  border-radius: 4px;
  padding: 12px;
  margin-top: 10px;
`;
MetadataTable.displayName = 'S.MetadataTable';

export const Tr = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
`;
Tr.displayName = 'S.Tr';

export const Property = styled.div`
  color: ${MOON_650};
  font-weight: 600;
  white-space: nowrap;
  width: 200px;
`;
Property.displayName = 'S.Property';

const GOLD1 = hexToRGB(GOLD_450, 0.14);
const GOLD2 = hexToRGB(GOLD_400, 0.14);
const highlightAnimation = keyframes`
    0%   {background-color: ${GOLD1};}
    25%  {background-color: ${GOLD2};}
    50%  {background-color: ${GOLD1};}
    75%  {background-color: ${GOLD2};}
    100% {background-color: ${Colors.TRANSPARENT};}
`;

export const Description = styled.div`
  width: 100%;
`;
Description.displayName = 'S.Description';

export const HighlightedDescription = styled.div`
  width: 100%;
  animation-name: ${highlightAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
`;
HighlightedDescription.displayName = 'S.HighlightedDescription';
